import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SpinnerService } from '../../../services/spinner.service';
import { RecurrentService } from '../../../services/recurrent.service';
import { CategoryService } from '../../../services/category.service';

@Component({
    selector: 'app-recurrent-view',
    templateUrl: './recurrent-view.component.html',
    styleUrls: ['./recurrent-view.component.css']
})
export class RecurrentViewComponent implements OnInit {
    recId: number;
    amount_multiplier: number = 1;
    rec: any = {
        id: null,
        date: new Date().toISOString().slice(0, 10),
        amount: 0,
        account: '',
        active: true,
        comment: '',
        category: null,
        recurrent: null,
        months: [
            { number: 0, active: true},
            { number: 1, active: true},
            { number: 2, active: true},
            { number: 3, active: true},
            { number: 4, active: true},
            { number: 5, active: true},
            { number: 6, active: true},
            { number: 7, active: true},
            { number: 8, active: true},
            { number: 9, active: true},
            { number: 10, active: true},
            { number: 11, active: true}
        ]
    };
    categories: any[] = [];
    get days(): number[] {
        return Array.apply(null, {length: 28}).map(Number.call, Number)
    }

    constructor(private route: ActivatedRoute,
        private router: Router,
        private spinner: SpinnerService,
        private recurrentService: RecurrentService,
        private categoryService: CategoryService) { }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.recId = +params['id'];
            this.getRecurrent();
            this.getCategories();
        });
    }

    getRecurrent() {
        this.spinner.startLoad('recurrent-view-getRecurrent');
        this.recurrentService.getRecurrent(this.recId).subscribe(
            (res) => this.formatRecurrent(res),
            (err) => console.error(err),
            () => this.spinner.finishLoad('recurrent-view-getRecurrent')
        );
    }

    getCategories() {
        this.spinner.startLoad('recurrent-view-getCategories');
        this.categoryService.getCategories().subscribe(
            (res) => this.categories = res,
            (err) => console.error(err),
            () => this.spinner.finishLoad('recurrent-view-getCategories')
        );
    }

    formatRecurrent(recurrent) {
        this.rec = recurrent;

        this.amount_multiplier = this.rec.amount < 0 ? -1 : 1;
        this.rec.amount = this.rec.amount * this.amount_multiplier;
    }

    saveRecurrent() {
        this.spinner.startLoad('recurrent-view-saveRecurrent');
        this.rec.amount = this.rec.amount * this.amount_multiplier;
        this.recurrentService.updateRecurrent(this.rec).subscribe(
            (res) => this.router.navigate(['/recurrent']),
            (err) => console.error(err),
            () => this.spinner.finishLoad('recurrent-view-saveRecurrent')
        );
    }

    monthToDate(month: number): Date {
        return new Date(new Date().setMonth(month));
    }

    setAllMonths(val: boolean) {
        this.rec.months = this.rec.months.map(function(month) {
            month.active = val;
            return month;
        });
    }
}
